import { Box, Heading } from 'grommet'
import styled from 'styled-components'

export const Wrapper = styled(Box)`
  text-align: left;
  white-space: pre-wrap;
  width: 100%;
`

export const Title = styled(Heading)`
  color: ${({ theme, color }) =>
    theme.colors[color] || color || theme.colors.white};
  font-size: ${({ theme }) => theme.fontSizes[12]}px;
  font-weight: ${({ theme }) => theme.fontWeight[7]};
  line-height: ${({ theme }) => theme.lineHeight[3]}px;
  text-transform: uppercase;
  white-space: pre-line;
  word-wrap: break-word;

  ${({ theme, $mobileFont }) => theme.below.mobileL`
    font-size: ${$mobileFont ? $mobileFont.fontSize : theme.fontSizes[13]}px;
    line-height: ${
      $mobileFont ? $mobileFont.lineHeight : theme.lineHeight[3]
    }px;
    text-transform: ${$mobileFont ? $mobileFont.transform : 'uppercase'};
  `}

  ${({ theme }) => theme.below.mobileM`
    ${theme.getTypography('mobile', 'title', 'title1')}
  `}

  ${({ theme }) => theme.below.mobileS`
    font-size: ${theme.fontSizes[4]}px;
    line-height: ${theme.lineHeight[2]}px;
  `}
`
